import React from "react";
import "./style.css";
import axios from "axios";
import AccessModal from "./access-modal";
import DeleteOutline from "@mui/icons-material/DeleteOutline";
import DriveFileRenameOutlineIcon from "@mui/icons-material/DriveFileRenameOutline";
import FactCheckOutlined from "@mui/icons-material/FactCheckOutlined";

import EditSessionModal from "./modal-editsession";

class SessionsList extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLogin: false,
      isLoaded: false,
      clinicUsers: null,
      sendMessage: "Hello,I'mInSessionsListPage",
      evaluation: null,
      currentDateTime: null,
      openModal: false,
      errorModal: false,
      modalClinicUser: "",
      modalUserId: "",
      videocallSession: false,
      userId: null,
      sessName: 0,
      sessResults: null,
      sessStats: null,
      openEditModal: false,
      sessionId: 0,
      currentUser: 0,
    };
  }

  getCurrentDateAndTime = () => {
    var today = new Date();
    var randDate = new Date("2022-5-3 7:0:0");

    var date =
      today.getFullYear() +
      "-" +
      (today.getMonth() + 1) +
      "-" +
      today.getDate();
    var time =
      today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
    var dateTime = date + " " + time;

    console.log("Current Date is:", dateTime);
    console.log("Current Date is:", today.getTime());
    console.log("Current Date is:", randDate < today);
  };

  componentDidMount = async () => {
    const userResult = await axios.get("https://request.kidiar.com/user/request", {
      headers: { "x-access-token": localStorage.getItem("token") },
    });
    localStorage.setItem("currentUser", userResult.data.access);
    if (userResult.data.message == "Yo, You are authenticated!") {
      // this.setState({isLogin: true});
      this.setState({ currentUser: userResult.data.user });
      // this.setState({firstName: userResult.data.firstname})
      // this.setState({lastName: userResult.data.lastname})
      console.log("1-", userResult.data);
    } else {
      // this.setState({isLogin: false});
      window.location.href = "https://www.mehrobo.com/fa/login";
    }
    this.handleRedirect();

    const search = window.location.search;
    const params = new URLSearchParams(search);
    const receivedId = params.get("id");
    console.log("received id in this page is:", receivedId);
    this.setState({ userId: parseInt(receivedId) });

    this.loadUserData(receivedId);
  };

  async loadUserData(id) {
    const response = await axios.post(
      "https://request.kidiar.com/sessions/results",
      { requestId: id },
      { headers: { "x-access-token": localStorage.getItem("token") } }
    );
    console.log("2-", response.data);
    this.setState({ sessResults: response.data.results.sessions });
    this.setState({ sessStats: response.data.results });
    if (response.data.message == "Yo, You are authenticated!") {
      this.setState({ isLogin: true });
      this.setState({ isLoaded: true });
    } else {
      this.setState({ isLogin: false });
      this.setState({ isLoaded: false });
      window.location.href = "https://www.mehrobo.com/fa/panel/evaluations";
    }
  }

  async handleRedirect() {
    const response = await axios.post("https://request.kidiar.com/pages/request", {
      sendMe: this.state.sendMessage,
    });
  }

  editSessionModal(sessId) {
    this.setState({ sessionId: sessId });
    this.setState({ openEditModal: true });
  }

  modalHandler(modal) {
    this.setState({ openEditModal: false });
  }

  render() {
    if (this.state.isLogin == false) {
      return <div className="container-fluid"></div>;
    }

    return (
      <div className="container-fluid">
        <div className="row no-gutters">
          <div className="col-12">
            <div className="d-flex mb-3 align-items-center">
              <div className="d-flex flex-column ml-2">
                <p className="d-flex mb-2 align-items-center">
                  <span className="font-medium font-18 mode-text-2">
                    لیست کاربران
                  </span>
                </p>
              </div>
            </div>
            <div className="test-list mt-1 d-flex flex-column">
              {this.state.openEditModal && (
                <EditSessionModal
                  closeModal={(modalBool) => this.modalHandler(modalBool)}
                  selectedUserId={this.state.userId}
                  selectedSession={this.state.sessResults[this.state.sessionId]}
                  currentUser={this.state.currentUser}
                />
              )}
              {this.state.errorModal && (
                <AccessModal
                  closeModal={(modalBool) => this.accessHandler(modalBool)}
                />
              )}

              <div className="panel mode-bg-8 mb-4">
                <div className="d-flex flex-column w-100">
                  <div className="test-title-wrapper d-flex justify-content-between align-items-center pr-4 pl-4">
                    <p className="font-14 mode-text-4">
                      لیست تست‌های انجام شده
                    </p>
                  </div>
                  <div className="test-table-wrapper">
                    <div className="test-table">
                      <div className="table-head">
                        <div className="test-table-header d-flex align-items-center justify-content-between mode-bg-5 pr-4 pl-4">
                          <p className="mode-text-9 w-15 ">ردیف</p>
                          <p className="mode-text-9 w-15">تاریخ</p>
                          <p className="mode-text-9 w-15 ">جلسه</p>
                          {/* <p className='mode-text-9 w-15 d-none-mobile'>نمره درصدی</p> */}
                          <p className="mode-text-9 w-15 ">جزئیات</p>
                        </div>
                      </div>
                      {this.state.sessResults.map((sessResult, i) => (
                        <div className="table-row" key={i}>
                          <a className="test-table-row w-100 d-flex align-items-center justify-content-between mode-bg-9 pr-4 pl-4">
                            <p className="mode-text-9 w-15">{i}</p>
                            <p className="mode-text-9 w-15">
                              {new Date(
                                sessResult.StartDate
                              ).toLocaleDateString("fa-IR")}
                            </p>
                            <p className="mode-text-9 w-15">
                              {sessResult.SessionName}
                            </p>
                            {/* <p className='mode-text-9 w-15 d-none-mobile'>{sessResult.Score}</p> */}
                            <a
                              className="cta-btn mode-bg-2"
                              onClick={() => this.editSessionModal(i)}
                            >
                              مشاهده
                            </a>
                          </a>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default SessionsList;
